<div class="register-container">
  <button
    mat-icon-button
    type="button"
    class="theme-toggle"
    [attr.aria-label]="(isDarkMode$ | async) === 'dark' ? 'Enable light mode' : 'Enable dark mode'"
    (click)="toggleTheme()">
    <mat-icon>{{ (isDarkMode$ | async) === 'dark' ? 'light_mode' : 'dark_mode' }}</mat-icon>
  </button>
  <mat-card class="register-card">
    <div class="register-branding">
      <img
        [src]="(isDarkMode$ | async) === 'dark'
          ? 'assets/tbds-commong-logo-full-dark.png'
          : 'assets/tbds-commong-logo-full-light.png'"
        alt="The Big Data Showroom"
        class="register-logo" />
    </div>
    <mat-card-header *ngIf="!reviewSubmitted">
      <mat-card-subtitle>
        {{ campaignMode && campaignName ? ('Join via ' + campaignName) : 'Create your account' }}
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content *ngIf="!reviewSubmitted">
      <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Surname</mat-label>
          <input matInput formControlName="surname" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width" *ngIf="inviteRequiresCompany">
          <mat-label>Company</mat-label>
          <input matInput formControlName="companyName" />
          <mat-error *ngIf="form.get('companyName')?.hasError('required')">Company is required</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width" *ngIf="(inviteMode || campaignMode) && !inviteRequiresCompany && inviteCompanyName">
          <mat-label>Organization</mat-label>
          <input matInput formControlName="companyName" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="email" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Mobile number</mat-label>
          <input
            matInput
            formControlName="phone"
            type="tel"
            inputmode="tel"
            autocomplete="tel"
            placeholder="072 123 1234"
            (blur)="onPhoneBlur()" />
          <mat-hint>South African mobile, e.g. 072 123 1234</mat-hint>
          <mat-error *ngIf="form.get('phone')?.hasError('required')">Mobile number is required</mat-error>
          <mat-error *ngIf="form.get('phone')?.hasError('saMobile')">
            Enter a valid South African mobile number
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>ID Number</mat-label>
          <input matInput formControlName="idNumber" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <input matInput formControlName="password" type="password" name="new-password" autocomplete="new-password" />
          <mat-hint>Use 8+ chars with uppercase, lowercase, and a special character.</mat-hint>
          <mat-error *ngIf="form.get('password')?.hasError('required')">Password is required</mat-error>
          <mat-error *ngIf="form.get('password')?.hasError('pattern')">
            Password must include uppercase, lowercase, and a special character.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Confirm Password</mat-label>
          <input
            matInput
            formControlName="confirmPassword"
            type="password"
            name="confirm-password"
            autocomplete="new-password" />
          <mat-error *ngIf="form.get('confirmPassword')?.hasError('required')">Confirm your password</mat-error>
          <mat-error *ngIf="passwordMismatch">Passwords do not match</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Industry</mat-label>
          <mat-select formControlName="industry">
            <mat-option *ngFor="let option of industryOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('industry')?.hasError('required')">Industry is required</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width" *ngIf="isOtherIndustrySelected">
          <mat-label>Please specify your industry</mat-label>
          <input matInput formControlName="industryOther" />
          <mat-error *ngIf="form.get('industryOther')?.hasError('required')">Industry detail is required</mat-error>
        </mat-form-field>
        <div class="id-upload" *ngIf="isRealEstateIndustrySelected">
          <label><strong>FFC document upload</strong></label>
          <div class="upload-actions">
            <button
              mat-stroked-button
              class="choose-file-button"
              color="primary"
              type="button"
              (click)="ffcUploadInput.click()">
              Choose File
            </button>
          </div>
          <input
            #ffcUploadInput
            class="file-input"
            hidden
            type="file"
            accept=".pdf,image/jpeg,image/png,image/webp"
            (change)="onFfcDocumentSelected($event)"
          />
          <div class="upload-meta" *ngIf="uploadedFfcFileName">
            <p><strong>File:</strong> {{ uploadedFfcFileName }}</p>
            <p class="upload-status-text" *ngIf="ffcUploadStatusMessage">{{ ffcUploadStatusMessage }}</p>
          </div>
          <small>Allowed file types: PDF, JPG, PNG, WEBP (max 5MB)</small>
        </div>
        <div class="id-upload">
          <label><strong>ID document upload</strong></label>
          <div class="upload-actions">
            <button
              mat-stroked-button
              class="choose-file-button"
              color="primary"
              type="button"
              (click)="uploadInput.click()">
              Choose File
            </button>
          </div>
          <input
            #uploadInput
            class="file-input"
            hidden
            type="file"
            accept=".pdf,image/jpeg,image/png,image/webp"
            (change)="onIdDocumentSelected($event)"
          />
          <div class="upload-meta" *ngIf="uploadedFileName">
            <p><strong>File:</strong> {{ uploadedFileName }}</p>
            <p class="upload-status-text" *ngIf="uploadStatusMessage">{{ uploadStatusMessage }}</p>
          </div>
          <small>Allowed file types: PDF, JPG, PNG, WEBP (max 5MB)</small>
        </div>
        <div class="terms-acceptance">
          <mat-checkbox formControlName="signupTermsAccepted" color="primary">
            I agree to the
            <a
              [href]="termsUrl"
              target="_blank"
              rel="noopener noreferrer"
              (click)="openExternalLink($event, termsUrl)"
            >Terms of Use</a>
            and understand the
            <a
              [href]="privacyUrl"
              target="_blank"
              rel="noopener noreferrer"
              (click)="openExternalLink($event, privacyUrl)"
            >Privacy &amp; POPIA Notice</a>.
          </mat-checkbox>
          <div class="terms-error" *ngIf="form.get('signupTermsAccepted')?.touched && form.get('signupTermsAccepted')?.invalid">
            You must accept the Terms of Use and Privacy &amp; POPIA Notice to continue.
          </div>
        </div>
        <button mat-raised-button color="primary" type="submit" class="full-width" [disabled]="form.invalid || loading">
          {{ loading ? 'Submitting...' : 'Submit registration' }}
        </button>
      </form>
    </mat-card-content>
    <mat-card-content *ngIf="reviewSubmitted">
      <div class="review-card">
        <mat-icon class="review-icon" color="primary">task_alt</mat-icon>
        <h2>Thank you for submitting your information</h2>
        <p>Your application is now in review.</p>
        <p>You will receive an email once your account has been approved.</p>
      </div>
    </mat-card-content>
  </mat-card>
</div>
